import EventBus from 'diagram-js/lib/core/EventBus';
import PathMap from 'bpmn-js/lib/draw/PathMap';
import Styles from 'diagram-js/lib/draw/Styles';
import Canvas from 'diagram-js/lib/core/Canvas';
import TextRenderer from 'bpmn-js/lib/draw/TextRenderer';
import {Connection, Shape} from 'diagram-js/lib/model';
import {is} from 'bpmn-js/lib/util/ModelUtil';
import {CustomRenderer} from '@ispm/shared/bpmn-io/custom-renderer';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {subProcessType, taskType} from '@ispm-shared/modules/bpmn/diagram-element-terms';
import {EventType} from "@ispm/shared/bpmn-io/bpmn-js";

export class TrackingChangesRenderer extends CustomRenderer {

  constructor(protected config: any, protected eventBus: EventBus, protected styles: Styles, protected pathMap: PathMap, protected canvas: Canvas, protected textRenderer: TextRenderer) {
    super(config, eventBus, styles, pathMap, canvas, textRenderer, 1002);
  }

  drawShape(visuals: SVGElement, element: Shape): SVGElement {
    const shape = super.drawShape(visuals, element);
    if (is(element, subProcessType) || is(element, taskType)) {
      this.addTrackingChangesVisuals(visuals, element);
    }
    return shape;
  }

  drawConnection(visuals: SVGElement, element: Connection): SVGElement {
    const connection = super.drawConnection(visuals, element);
    this.addTrackingChangesVisualsForConnections(visuals, element);

    return connection;
  }


  private addTrackingChangesVisuals(visuals: SVGElement, element) {

    const trackingChange = ModelingUtil.getTrackingChange(element);
    if (trackingChange) {
      const trackingChangeType = trackingChange.type;
      const className = `tracking-changes-${trackingChangeType}`;
      const textBGRectArr = visuals.getElementsByClassName(className);
      const textElm = visuals.getElementsByTagName('text')[0];
      const cssClasses = textElm.getAttribute('class');
      textElm.setAttribute('class', cssClasses + ' ' + `${className}-text`);
      if (textBGRectArr.length === 0 && trackingChangeType !== 'deleted') {
        const textBG = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        textBG.setAttribute('class', className);
        visuals.insertBefore(textBG, textElm);

        const textbBox = textElm.getBBox();
        const bgRect = textBGRectArr[0];
        bgRect.setAttribute('x', `${textbBox.x}`);
        bgRect.setAttribute('y', `${textbBox.y}`);
        bgRect.setAttribute('width', `${textbBox.width}`);
        bgRect.setAttribute('height', `${textbBox.height}`);
      } else {
        const rectElm = visuals.getElementsByTagName('rect')[0];
        rectElm.setAttribute('class', className);

      }
      if (trackingChangeType === 'deleted') {
        this.eventBus.fire(EventType.MARKED_DELETED_NODE, {node: element});
      }
    }
  }

  private addTrackingChangesVisualsForConnections(visuals: SVGElement, element) {
    const trackingChange = ModelingUtil.getTrackingChange(element);
    if (trackingChange) {
      const trackingChangeType = trackingChange.type;
      const className = `tracking-changes-${trackingChangeType}-connection`;
      const polyline = visuals.getElementsByTagName('polyline')[0];
      polyline.setAttribute('class', className);
      if (trackingChangeType === 'deleted') {
        this.eventBus.fire(EventType.MARKED_DELETED_CONNECTION, {connection: element});
      }
    }
  }

}
